module.exports = __webpack_public_path__ + "static/media/eg-paper.3598c710.png";